import { useContext, useState } from 'react';
import ClientContext from '@/contexts/client.context';

// Components
import useReducedMotion from '@/utils/useReducedMotion';
import useIsTouchDevice from '@/utils/useIsTouchDevice';
import VideoPlayerModal from '@/components/shared/VideoPlayerModal';
import EnrollButton from '../../core/EnrollButton';

// Utils
import getImgSrcWorkaround from '@/utils/images';
import PlaySVG from '@/public/icons/ic_play.svg';
import { products } from '@/utils/products';

// Styles
import {
  Wrapper,
  StyledContainer,
  VideoContainer,
  Content,
  TextContainer,
  TitleWrapper,
  Button,
  ButtonWrapper,
} from './styles';
import { Heading, SectionHeader } from '@swordhealth/ui-corporate';

export const VideoSection = ({ content, scrollTop, isOrganicLP }) => {
  const {
    previewVideo,
    video,
    videoTitle,
    heroWithButtons,
    upperLabel,
    btnPlayVideo,
    showEnrollBtn,
    buttonLabel,
  } = content;
  const { client, openModal } = useContext(ClientContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const prefersReducedMotion = useReducedMotion();
  const isTouchDevice = useIsTouchDevice();
  const previewVideoUrl = previewVideo?.url ?? previewVideo?.data?.attributes?.url;
  const videoUrl = video?.url ?? video?.data?.attributes?.url;

  if (!previewVideoUrl || !videoUrl) return null;

  return (
    <StyledContainer>
      {heroWithButtons && <SectionHeader label={upperLabel} {...heroWithButtons} />}
      <Wrapper>
        <VideoPlayerModal
          modalIsOpen={modalIsOpen}
          closeModal={() => setModalIsOpen(false)}
          videoURL={videoUrl}
        />

        <VideoContainer id="video_media" autoPlay={!prefersReducedMotion} playsInline loop muted>
          <source src={getImgSrcWorkaround(previewVideoUrl ?? videoUrl)} />
        </VideoContainer>

        <Content $touch={isTouchDevice}>
          <TextContainer>
            <TitleWrapper id="video_title">
              <Heading size="2xl">
                {videoTitle ?? previewVideo?.caption ?? previewVideo?.data?.attributes?.caption}
              </Heading>
            </TitleWrapper>
            <Button id="video_button" variant="secondary" onClick={() => setModalIsOpen(true)}>
              <PlaySVG /> {btnPlayVideo ?? 'Play video'}
            </Button>
          </TextContainer>
        </Content>
      </Wrapper>
      {showEnrollBtn && (
        <ButtonWrapper>
          <EnrollButton
            isActive={client.isActive}
            buttonLocation="Video section"
            openModal={() =>
              openModal({
                buttonText: buttonLabel ?? 'Get Started',
                buttonLocation: 'video section',
              })
            }
            client={client}
            buttonLabel={buttonLabel ?? 'Get Started'}
            scrollTop={scrollTop}
            product={products[client?.product?.key?.toUpperCase()]}
            redirectToApp={client?.redirectToApp}
            triage={client?.hasTriage}
            isOrganicLP={isOrganicLP}
          />
        </ButtonWrapper>
      )}
    </StyledContainer>
  );
};

VideoSection.defaultConfig = {
  rounded: false,
  colored: false,
  spaceBottom: true,
  spaceTop: false,
  marginBottom: false,
};

export default VideoSection;
